var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotification)?_c('div',{staticClass:"alert alert-warning mb-0"},[_c('span',[_vm._v(_vm._s(_vm.notificationMessage))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }